import Vue from 'vue';

const TTL = 5 * 60 * 1000; // 5 minutes

const state = Vue.observable({
    viewers: {}
    // Structure: { [ticketId]: { [viewerKey]: { name, userId, expiresAt } } }
});

let cleanupInterval = null;

function startCleanup() {
    if (cleanupInterval) return;
    cleanupInterval = setInterval(() => {
        let now = Date.now();
        for (let ticketId in state.viewers) {
            for (let key in state.viewers[ticketId]) {
                if (state.viewers[ticketId][key].expiresAt <= now) {
                    Vue.delete(state.viewers[ticketId], key);
                }
            }
            if (Object.keys(state.viewers[ticketId]).length === 0) {
                Vue.delete(state.viewers, ticketId);
            }
        }
    }, 30000);
}

export function trackViewer(ticketId, userId, name) {
    if (!state.viewers[ticketId]) {
        Vue.set(state.viewers, ticketId, {});
    }
    Vue.set(state.viewers[ticketId], String(userId), {
        name,
        userId,
        expiresAt: Date.now() + TTL
    });
    startCleanup();
}

export function removeViewer(ticketId, userId) {
    if (state.viewers[ticketId]) {
        Vue.delete(state.viewers[ticketId], String(userId));
        if (Object.keys(state.viewers[ticketId]).length === 0) {
            Vue.delete(state.viewers, ticketId);
        }
    }
}

export function getViewers(ticketId, excludeUserId) {
    let viewers = state.viewers[ticketId];
    if (!viewers) return [];
    let now = Date.now();
    return Object.values(viewers).filter(v => v.expiresAt > now && v.userId !== excludeUserId);
}

export default state;
